// CommentListPaged.tsx
'use client'

import React, { useContext, useEffect, useMemo, useState } from "react";
import { CommentListType } from "@/type/list";
import { with_comma } from "@/util/comma";
import { AuthContext } from "@/context/authContext";
import customAlert from "@/util/customAlert";
import api from "@/util/api";
import { useTranslations } from "next-intl";
import LocaleFormat from "../etc/localeFormat";

type Props = {
    comments: CommentListType[];
    initialPageSize?: number;
    post:string
    setSelectContent?: Function,

};

export default function CommentListPaged({ comments, initialPageSize = 5, post , setSelectContent }: Props) {
    const [localComments, setLocalComments] = useState<CommentListType[]>(comments);

    const t = useTranslations("Text")
    const a = useTranslations("Sentence")

    useEffect(() => {
        setLocalComments(comments);
// console.log("comments:",comments);
    }, [comments]);

    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(initialPageSize);

    // const total = comments.length;
    
    const [deletedIds, setDeletedIds] = useState<Set<string>>(new Set());
    const total = localComments.length - deletedIds.size;
    const totalPages = Math.max(1, Math.ceil(total / pageSize));
    const { user } = useContext(AuthContext)

    // 현재 페이지 항목
    const pageItems = useMemo(() => {
        const start = (page - 1) * pageSize;
        // 페이지 슬라이스 후 삭제된 id 필터링
        return localComments
            .slice(start, start + pageSize)
            .filter(cm => !deletedIds.has(String(cm.id ?? `${start + (localComments.indexOf(cm) - start)}`)));
    }, [localComments, page, pageSize, deletedIds]);


    // 페이징 버튼 창(5개씩)
    const getPageWindow = () => {
        const windowSize = 5;
        let start = Math.max(1, page - Math.floor(windowSize / 2));
        let end = start + windowSize - 1;
        if (end > totalPages) {
            end = totalPages;
            start = Math.max(1, end - windowSize + 1);
        }
        const arr: number[] = [];
        for (let i = start; i <= end; i++) arr.push(i);
        return arr;
    };

    const goto = (p: number) => setPage(Math.min(Math.max(1, p), totalPages));


    
    const [editingIndex, setEditingIndex] = useState<string | null>(null) 
    const [editValue, setEditValue] = useState<string>('')
    const [edits, setEdits] = useState<Record<string, string>>({}) 
    const [loadingIdx, setLoadingIdx] = useState<string | null>(null)

    function handleEdit(id:number) {
    
        // console.log("setEditValue", editValue);
        if(!editValue || editValue == ""){
            customAlert(a("InvalidComments"), 'warning')
            return;
        }
        const formData = new FormData()
        formData.set('type', 'update')
        formData.set('comment_id', `${id}`)
        formData.set('comment_content', `${editValue}`)
        // console.log('as object', Object.fromEntries(formData.entries()));

        api(`${post}comment/edit/`, { method: "POST", body: formData })
            .then(res => res.json())
            .then(({data, status_code, message}) => {
                // console.log(data)

                customAlert(message, status_code==200 ? 'success':'warning')
                if(status_code == 200){
                    const newContent = data?.content ?? data?.comment_content ?? editValue;
                    setEdits(prev => ({ ...prev, [id]: newContent }));
                }
                cancelEdit()

            })
            .catch((error: Response) =>{
// console.log(error)
            })
    }


    async function deletecomment(id:number) {


        await customAlert(a("IsDeleteComments"), "question", () => {

                cancelEdit()
                const formData = new FormData()
                formData.set('comment_id', `${id}`)
                // console.log('as object', Object.fromEntries(formData.entries()));

                api(`${post}comment/delete/`, { method: "POST", body: formData })
                    .then(res => res.json())
                    .then(({data, status_code, message}) => {
                        // console.log(data, status_code, message)

                        customAlert(message, status_code==200 ? 'success':'warning')
                        if(status_code == 200){
                            if (typeof setSelectContent === "function") {
                                setSelectContent((prev: any) => ({
                                    ...prev,
                                    comments: prev.comments.filter((c:any) => String(c.id) !== String(id))
                            }))
                            setPage(prev => {
                                const newTotal = localComments.length - 1
                                const newTotalPages = Math.max(1, Math.ceil(newTotal / pageSize))
                                return Math.min(prev, newTotalPages)
                            })
                        }
                        }

                    })
                    .catch((error: Response) =>{
                        // console.log(error)
                    })
                    
            }, {
                confirmMode: true,
                onCancel: () => {return false},
            });


        

    }

    function openEditById(id: number | string) {
        const cm = pageItems.find(p => String(p.id) === String(id));
        if (!cm) return;
        const key = String(cm.id ?? `${(page-1)*pageSize + pageItems.indexOf(cm)}`);
        const initial = edits[key] ?? cm.content ?? '';
        setEditingIndex(key);
        setEditValue(typeof initial === 'string' ? initial : String(initial));
    }
    
    function cancelEdit() {
        setEditingIndex(null)
        setEditValue('')
    }

    if (!comments || comments.length === 0) return null;
    
    return (
        <div className="comment-list-container-new">
            <div className={`listTitle`}>
                <span>{t("댓글")}</span>
                <span>{with_comma(total)}</span>
            </div>

            <ul className="comment-list-new">
                {pageItems.map((cm, idx) => {
                    
                    const key = String(cm.id ?? `${(page-1)*pageSize + idx}`)
                    const currentContent = edits[key] ?? cm.content
                    const isEditing = editingIndex === key
                    return  (
                        // <li key={cm.id}>
                        <li key={key}>
                            <div>
                                <div className={`name flex start m-b-10`}>
                                    <div className={`profile_image`}>
                                        {/* {cm.profile_image && (  */}
                                            <img src={`${cm.profile_image || "/image/etc/no_profile_image.png"}`} 
                                                    onError={(e) => {
                                                        e.currentTarget.onerror = null;
                                                        e.currentTarget.src = `${require('@/public/image/etc/no_profile_image.png').default.src}`; 
                                                    }}/> 
                                        {/* )} */}
                                    </div>
                                    <div className={`profile_name m-l-5`}>
                                        {cm.author_name}
                                    </div>
                                </div>
                                <div className={`date`}>{<LocaleFormat date={cm.create_dt} format="MM-DD HH:mm" />}</div>
                            </div>
                            
                            {isEditing  ? (
                                <>
                                    <div>
                                        <textarea value={editValue}
                                                onChange={(e) => setEditValue(e.target.value)}
                                                className={`commentEditArea`}>{cm.content}</textarea>
                                    </div>
                                    <div className={`btn flex flex_end`}>
                                        <button onClick={ ()=>handleEdit(cm.id) }>{t("저장")}</button>
                                        <button onClick={ ()=>cancelEdit() }>{t("취소")}</button>
                                    </div>  
                                </>
                            ):(
                                <>
                                    <div className={`content`} style={{ whiteSpace: 'pre-wrap' }}>
                                        {/* {cm.content} */}
                                        {currentContent}
                                    </div>
                                    { user.is_authenticated && cm.is_author &&
                                        <div className={`btn flex flex_end`}>
                                            <button onClick={ ()=>openEditById(cm.id ?? key) }>{t("수정")}</button>
                                            <button onClick={ ()=>deletecomment(cm.id) }>{t("삭제")}</button>
                                        </div>  
                                    }
                                </>
                            )}
                        </li>
                    )
                })}
            </ul>

            {getPageWindow().length > 1 && 
                <div className="paging-controls">
                    <button onClick={() => goto(1)} disabled={page === 1}>«</button>
                    <button onClick={() => goto(page - 1)} disabled={page === 1}>‹</button>

                    {getPageWindow().map(p => (
                    <button
                        key={p}
                        className={p === page ? 'active' : ''}
                        onClick={() => goto(p)}
                    >
                        {p}
                    </button>
                    ))}

                    <button onClick={() => goto(page + 1)} disabled={page === totalPages}>›</button>
                    <button onClick={() => goto(totalPages)} disabled={page === totalPages}>»</button>

                    {/* <select
                    value={pageSize}
                    onChange={(e) => { setPageSize(Number(e.target.value)); setPage(1); }}
                    aria-label="페이지 사이즈"
                    >
                    {[5, 10, 20, 50].map(n => <option key={n} value={n}>{n}개</option>)}
                    </select> */}

                    {/* <span className="paging-info"> {page} / {totalPages} 페이지</span> */}
                </div>
            }
        </div>
    );
}
